<div class="download-saved-snackbar">
  <span class="message">{{ data.message }}</span>
  <div class="actions">
    <button mat-button class="action-btn" (click)="onPrimary()">{{ data.primaryLabel }}</button>
    <button mat-button class="action-btn" (click)="onSecondary()">{{ data.secondaryLabel }}</button>
    <button mat-icon-button class="dismiss-btn" (click)="onDismiss()" aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
